import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from 'sonner';
import { HelmetProvider } from 'react-helmet-async';
import HomePage from "./pages/HomePage";
import LandingPage from "./pages/LandingPage";
import LLCPage from "./pages/services/LLCPage";
import CorporationPage from "./pages/services/CorporationPage";
import TrademarkPage from "./pages/services/TrademarkPage";
import WillPage from "./pages/services/WillPage";
import DBAPage from "./pages/services/DBAPage";
import NonprofitPage from "./pages/services/NonprofitPage";
import TrustPage from "./pages/services/TrustPage";
import PowerOfAttorneyPage from "./pages/services/PowerOfAttorneyPage";
import RegisteredAgentPage from "./pages/services/RegisteredAgentPage";
import AnnualReportPage from "./pages/services/AnnualReportPage";
import BusinessLicensePage from "./pages/services/BusinessLicensePage";
import OperatingAgreementPage from "./pages/services/OperatingAgreementPage";
import DissolutionPage from "./pages/services/DissolutionPage";
import CopyrightPage from "./pages/services/CopyrightPage";
import PatentPage from "./pages/services/PatentPage";
import HealthcareDirectivePage from "./pages/services/HealthcareDirectivePage";
import DivorcePage from "./pages/services/DivorcePage";
import SoleProprietorshipPage from "./pages/services/SoleProprietorshipPage";
import BusinessCreditPage from "./pages/services/BusinessCreditPage";
import VirtualMailPage from "./pages/services/VirtualMailPage";
import ResidentialLeasePage from "./pages/services/ResidentialLeasePage";
import PropertyDeedPage from "./pages/services/PropertyDeedPage";
import BusinessAttorneyPage from "./pages/services/BusinessAttorneyPage";
import PersonalAttorneyPage from "./pages/services/PersonalAttorneyPage";
import TrademarkAttorneyPage from "./pages/services/TrademarkAttorneyPage";
import CompliancePage from "./pages/services/CompliancePage";
import TrademarkSearchPage from "./pages/services/TrademarkSearchPage";
import TrademarkMonitoringPage from "./pages/services/TrademarkMonitoringPage";
import RegisterBusinessPage from "./pages/services/RegisterBusinessPage";
import AboutUsPage from "./pages/AboutUsPage";
import ContactUsPage from "./pages/ContactUsPage";
import BlogPost1 from "./pages/BlogPost1";
import BlogPost2 from "./pages/BlogPost2";
import BlogPost3 from "./pages/BlogPost3";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import LegalDisclaimer from "./pages/LegalDisclaimer";
import ThankYouPage from "./pages/ThankYouPage";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/lp" element={<LandingPage />} />
          
          {/* Business Services */}
          <Route path="/services/llc" element={<LLCPage />} />
          <Route path="/services/corporation" element={<CorporationPage />} />
          <Route path="/services/dba" element={<DBAPage />} />
          <Route path="/services/nonprofit" element={<NonprofitPage />} />
          <Route path="/services/sole-proprietorship" element={<SoleProprietorshipPage />} />
          <Route path="/services/register-business" element={<RegisterBusinessPage />} />
          <Route path="/services/compliance" element={<CompliancePage />} />
          <Route path="/services/annual-report" element={<AnnualReportPage />} />
          <Route path="/services/licenses" element={<BusinessLicensePage />} />
          <Route path="/services/operating-agreement" element={<OperatingAgreementPage />} />
          <Route path="/services/registered-agent" element={<RegisteredAgentPage />} />
          <Route path="/services/virtual-mail" element={<VirtualMailPage />} />
          <Route path="/services/dissolution" element={<DissolutionPage />} />
          <Route path="/services/business-credit" element={<BusinessCreditPage />} />
          <Route path="/services/trademark" element={<TrademarkPage />} />
          <Route path="/services/trademark-search" element={<TrademarkSearchPage />} />
          <Route path="/services/free-trademark" element={<TrademarkSearchPage />} />
          <Route path="/services/trademark-monitoring" element={<TrademarkMonitoringPage />} />
          <Route path="/services/patent" element={<PatentPage />} />
          <Route path="/services/copyright" element={<CopyrightPage />} />
          
          {/* Personal Services */}
          <Route path="/services/will" element={<WillPage />} />
          <Route path="/services/trust" element={<TrustPage />} />
          <Route path="/services/power-of-attorney" element={<PowerOfAttorneyPage />} />
          <Route path="/services/healthcare-directive" element={<HealthcareDirectivePage />} />
          <Route path="/services/divorce" element={<DivorcePage />} />
          <Route path="/services/residential-lease" element={<ResidentialLeasePage />} />
          <Route path="/services/deed-transfer" element={<PropertyDeedPage />} />
          <Route path="/services/estate-planning" element={<WillPage />} />
          
          {/* Attorney Services */}
          <Route path="/services/business-attorney" element={<BusinessAttorneyPage />} />
          <Route path="/services/personal-attorney" element={<PersonalAttorneyPage />} />
          <Route path="/services/trademark-attorney" element={<TrademarkAttorneyPage />} />
          <Route path="/services/other-legal" element={<LLCPage />} />
          
          {/* Company Pages */}
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/contact" element={<ContactUsPage />} />
          
          {/* Blog Pages */}
          <Route path="/blog/llc-formation-guide" element={<BlogPost1 />} />
          <Route path="/blog/estate-planning-essentials" element={<BlogPost2 />} />
          <Route path="/blog/trademark-protection" element={<BlogPost3 />} />
          
          {/* Legal Pages */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/legal-disclaimer" element={<LegalDisclaimer />} />
          
          {/* Thank You Page */}
          <Route path="/thanks" element={<ThankYouPage />} />
          
          {/* Support */}
          <Route path="/support" element={<HomePage />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
